import { render, staticRenderFns } from "./RegisterEmployeeView.vue?vue&type=template&id=8311d7aa&scoped=true&"
import script from "./RegisterEmployeeView.vue?vue&type=script&lang=js&"
export * from "./RegisterEmployeeView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterEmployeeView.vue?vue&type=style&index=0&id=8311d7aa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8311d7aa",
  null
  
)

export default component.exports